import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Badge from '@material-ui/core/Badge';
import Icon from '@material-ui/core/Icon';

const StyledBadge = withStyles((theme) => ({
  badge: {
    top: '75%',
    lineHeight: 1,
    color: theme.palette.primary.main,
    background: theme.palette.secondary.main,
    border: `.1875rem solid ${
      theme.palette.type === 'light'
        ? theme.palette.grey[50]
        : theme.palette.grey[900]
    }`,
  },
}))(Badge);

const BadgeIcon = ({ icon, count, color, small = false }) => {
  const [counter, setCounter] = useState(count);

  useEffect(() => {
    setCounter(count);
  }, [count]);

  const styles = { fontSize: small ? '1.5rem' : '2rem' };
  if (small) {
    styles.color = 'inherit';
  }
  if (icon === 'gif') {
    styles.transform = 'scale(1.25)';
  }

  return (
    <StyledBadge badgeContent={counter} color="primary">
      <Icon color={color} style={styles}>
        {icon}
      </Icon>
    </StyledBadge>
  );
};

BadgeIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  color: PropTypes.string,
};

BadgeIcon.defaultProps = { color: 'action', count: 0 };

export default BadgeIcon;
